import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from 'react-router-dom';
import {useDispatch, useSelector, shallowEqual} from 'react-redux';
import {RootContainer, LoginContainer, InputContainer, Input, SubmitButton, PageHeader, LoaderContainer, UnderlinedButton} from './ResetPassword.styles'
import {authActions} from 'modules/auth';
import PropagateLoader from 'react-spinners/PropagateLoader'

export default () => {
	const dispatch = useDispatch()
	const history = useHistory();
	const {resetId} = useParams();
	const authState = useSelector(state => state.authReducer);
	const [password, setPassword] = useState('');

	const onVerifyPress = () => {
		// console.log("reset", resetId, password)
		dispatch(authActions.resetPasswordAsyncActions.request({id: resetId, password}))
	}

	return (
		<RootContainer>
			<LoginContainer>
				<PageHeader>Reset Password</PageHeader>
				<InputContainer>
					<Input placeholder="Password" type="password" fullWidth onChange={evt => setPassword(evt.target.value)} />
				</InputContainer>
				{
					authState.isLoading
					?
					<PropagateLoader size={15} color="#7289da" />
					:
					<LoaderContainer>
						<SubmitButton onClick={onVerifyPress} >Reset Password</SubmitButton>
					</LoaderContainer>
				}
				{
					authState.resetSuccess
					?
					<UnderlinedButton onClick={() => history.push('/')} >Back to login</UnderlinedButton>
					:
					null

				}
			</LoginContainer>
		</RootContainer>
	)
}